<div class="modal-body">
  <h3>
    Are you sure that you want to <strong>Delete</strong> Workspace:
    {{ workspaceToDelete?.name }}?
  </h3>
  <p class="ml-3">{{ workspaceToDelete?.description }}</p>
  <em>
    <small>
      * Once deleted all information regarding the layout, panel placement and
      grid views will be lost.
    </small>
  </em>
</div>
<div class="modal-footer">
  <button nf-button ngbAutoFocus (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="delete" (click)="activeModal.close()"></button>
</div>
